module.exports = __webpack_public_path__ + "img/sardou-60ans.db694e6e.jpg";